import { createContext } from "react";

const MainContext = createContext({
  fetchdata : () =>{},
  setAccountType : () => {},
  setReligion : () => {},
  setBranch: () => {},
  setAddress: () => {},
  setBVN : () => {},
        setAltPhone: () => {},
        setAltEmail: () => {},
        setCurrentAddress: () => {},
        setmotherMaidenName: () => {},
       
        setOccupation: () => {},
        setRmCode:()=>{},
        
        setCustomerId: () => {},

  bvn : "",
  accountType: "",
  address: "",
  religion: "",
  customerId:"",
  altEmail:"",
  altPhone:"",
  branch:"",
  occupation:"",
  motherMaidenName:"",
  currentAddress:"",
  rmCode:""
  

});

export default MainContext;
